import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCz = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "flag-icons-cz",
	viewBox: "0 0 640 480",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h640v240H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d7141a",
			d: "M0 240h640v240H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#11457e",
			d: "M360 240 0 0v480z"
		})
	]
});
export default SvgCz;
